import React from 'react';
import './navbar.css';
import {
  Navbar,
  Nav,
  NavDropdown
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {show:false};
    // To use the 'this' keyword, we need to bind it to our function
    this.showDropDown = this.showDropDown.bind(this);
    this.hideDropDown = this.hideDropDown.bind(this);
  }

  showDropDown(){
    this.setState({show:true})
  }

  hideDropDown(){
    this.setState({show:false})
  }


  render() {
    return (
      <div className="navbar-wrapper">
      <Navbar collapseOnSelect expand="lg" sticky="top" bg="light" variant="light" style={{ padding : "0px"}}>
        <Navbar.Brand as={Link} to="/">
          <img
            src="/content/Home/Logo/Title 2.png"
            className="d-inline-block align-top"
            alt="RAW logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
          <Nav.Link as={Link} to="/projects">works</Nav.Link>
            <NavDropdown title="about" show={this.state.show}  onMouseEnter={this.showDropDown} 
   onMouseLeave={this.hideDropDown} id="collasible-nav-dropdown" >
              <NavDropdown.Item as={Link} to="/about/aboutUs">about us</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/team">team</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/awards">awards</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/publications">publications</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/talks">talks</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/contact">contacts</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      </div>
    );
  }
}

export default NavBar;
